
document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('[data-dogi-menu]');
  const nav = document.querySelector('[data-dogi-nav]');
  if (menu && nav) {
    menu.addEventListener('click', function () {
      const open = nav.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-story-toggle]').forEach(function(button) {
    button.addEventListener('click', function() {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const hidden = target.hasAttribute('hidden');
      if (hidden) {
        target.removeAttribute('hidden');
        button.textContent = 'Close full story ↑';
        button.setAttribute('aria-expanded', 'true');
      } else {
        target.setAttribute('hidden', '');
        button.textContent = 'Read the full story →';
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
